'use client';

import useMinifyChecker from '@/hooks/useMinifyChecker';

import LeftSidebar from '../Login/sections/LeftSidebar';
import SignupForm from './sections/SignupForm';

const SignupPage = ({ tenant }: any) => {
  const { minify } = useMinifyChecker();

  return (
    <div className="h-screen bg-zinc-100 p-[24px]">
      <div className={`bg-white rounded-3xl ${minify ? 'grid-cols-1' : 'grid-cols-2'} grid`}>
        <SignupForm tenant={tenant} />
        {!minify && <LeftSidebar />}
      </div>
    </div>
  );
};
export default SignupPage;
